// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"ad2739b8","887":"0664c6d8"}[chunkId] + ".chunk.js";
};